<template>
  <!-- <div class="text-md-center" > -->
     <div class="text-center">
    <v-menu offset-y absolute v-model="lmenu" :close-on-content-click="false" :full-width="true">
      <v-btn :depressed="true" slot="activator" block>
        <span v-if="totalVehicles === 0">Number of Vehicles</span> <span v-if="totalVehicles >= 1">{{totalVehicles}} Vehicles</span>
      </v-btn>
      <!-- <v-list style="width: 20vw"> -->
           <v-list >
        <v-list-tile row v-for="(vehicles, key) in allVehicles" :key="key" :disabled="$vehicleDisabled">
          <v-container>
            <v-layout row>
              <v-flex md6 sm6 xs6 align-center>
                <p class="body-2">{{vehicles.vehicle_charge_category}} ({{vehicles.vehicle_charge_cost_currency}} {{vehicles.vehicle_charge_category_cost}})</p>
              </v-flex>
              <v-flex lg2 md2 sm2 xs2 align-center>
                <v-btn-toggle>
                  <v-btn :depressed="true" @click="reduceVehicles(key)" round small color="error"><v-icon>remove</v-icon></v-btn>
                </v-btn-toggle>
              </v-flex>
              <v-flex lg2 md2 sm2 xs2 align-center>
                <h4 class="text-md-center text-sm-center text-xs-center">{{allVehicles[key].vehicles}}</h4>
              </v-flex>
              <v-flex lg2 md2 sm2 xs2 align-center>
                <v-btn-toggle>
                  <v-btn :depressed="true" @click="addVehicles(key)" small color="primary"><v-icon>add</v-icon></v-btn>
                </v-btn-toggle>
              </v-flex>
            </v-layout>
          </v-container>
        </v-list-tile>
        <v-list-tile>
          <!-- <v-container style="width: 25vw"> -->
            <v-container>
            <v-checkbox
              v-model="checkbox"
              @change="updateVehicles()"
              label="Vehicle fee already booked separately."
              :persistent-hint="true"
              color="primary"
            ></v-checkbox>
          </v-container>
        </v-list-tile>
        <br>
        <v-list-tile>
          <v-layout row wrap>
            <v-flex md4 lg4 sm4 xs12 offset-lg7 offset-md7 offset-sm7 align-center>
              <v-btn :depressed="true" dark small block color="primary" @click="lmenu = false">Apply</v-btn>
            </v-flex>
          </v-layout>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'vehicle',
  data () {
    return {
      lmenu: false,
      checkbox: false,
      items: [
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me 2' }
      ]
    }
  },
  created () {
    this.checkbox = this.$vehicleDisabled
    if (JSON.parse(localStorage.getItem('vehicle_data')).length !== 0) {
      this.$store.commit('LOCAL_VEHICLES', JSON.parse(localStorage.getItem('vehicle_data')))
    } else {
      this.$store.dispatch('get_all_vehicle_fees')
    }
  },
  methods: {
    updateVehicles () {
      if (this.checkbox === true) {
        this.$store.commit('VEHICLE_SEPARATE', true)
        this.allVehicles.map(function (vehicle) {
          vehicle.vehicles = 0
        })
        this.$store.commit('DISABLED_STATUS', true)
      } else {
        this.$store.commit('VEHICLE_SEPARATE', false)
        this.$store.commit('DISABLED_STATUS', false)
      }
    },
    reduceVehicles: function (key) {
      var vehicles = this.allVehicles[key].vehicles
      if (vehicles > 0) {
        vehicles = Number(vehicles) - 1
        this.allVehicles[key].vehicles = vehicles
      }
    },
    addVehicles: function (key) {
      var vehicles = this.allVehicles[key].vehicles
      vehicles = Number(vehicles) + 1
      this.allVehicles[key].vehicles = vehicles
    }
  }
}
</script>

<style scoped>

</style>
